import { render, staticRenderFns } from "./DiviDends_page.vue?vue&type=template&id=69ae4997"
import script from "./DiviDends_page.vue?vue&type=script&lang=js"
export * from "./DiviDends_page.vue?vue&type=script&lang=js"
import style0 from "./DiviDends_page.vue?vue&type=style&index=0&id=69ae4997&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports